<template>
  <div class="flex items-start flex-wrap lg:flex-no-wrap relative">
    <div
      v-if="formReady && !formCreate"
      class="
        w-full
        mb-6
        lg:order-2
        lg:ml-10
        lg:w-4/12
        lg:sticky
        lg:right-0
        lg:top-0
        xl:w-4/12
      "
    >
      <h1 class="font-medium poppins mb-2 text-lg">Ticket Information</h1>

      <div class="border-b text-sm p-4 border-gray-200 bg-white">
        <p>{{ formData.subject }}</p>
        <p>#{{ $route.params.id }}</p>
        <p :class="parseStatus(formData.status).color" class="mt-2">
          <font-awesome-icon :icon="['fas', 'circle']" class="mr-2" />{{
            parseStatus(formData.status).name
          }}
        </p>
      </div>
      <div class="border-b text-sm p-4 border-gray-200 bg-white">
        <p class="text-gray-600">Category</p>
        <p>{{ formData.category.name }}</p>
      </div>
      <div class="border-b text-sm p-4 border-gray-200 bg-white">
        <h2 class="text-gray-600">Submitted</h2>
        <p>{{ dateformat(formData.created_at) }}</p>
      </div>
      <div class="text-sm p-4 border-gray-200 bg-white">
        <h2 class="text-gray-600">Last Updated</h2>
        <p>{{ relativeTimeFormat(formData.updated_at) }}</p>
      </div>

      <div class="flex justify-between mt-2">
        <button
          v-if="allowProcess() && userCan('admin.helpdesk')"
          class="
            flex
            items-center
            justify-center
            rounded
            focus:outline-none
            transition-colors
            duration-150
            text-sm
            p-3
            poppins
            bg-teal-500
            hover:bg-teal-600
            focus:bg-teal-600
            text-white
            w-1/2
            mr-2
          "
          type="button"
          @click="processTicket(1)"
        >
          Process Ticket
        </button>
        <button
          v-else-if="
            userCan('create.helpdesk') &&
            ticketStatus != 4 &&
            !userCan('admin.helpdesk')
          "
          class="
            flex
            items-center
            justify-center
            rounded
            focus:outline-none
            transition-colors
            duration-150
            text-sm
            p-3
            poppins
            bg-teal-500
            hover:bg-teal-600
            focus:bg-teal-600
            text-white
            w-1/2
            mr-2
          "
          type="button"
          v-scroll-to="{ el: '#replyTicket', duration: 1500 }"
          @click="replyOpen = true"
        >
          Reply Ticket
        </button>
        <button
          v-if="
            userCan('create.helpdesk') &&
            (ticketStatus == 0 || ticketStatus == 2 || ticketStatus == 3)
          "
          class="
            flex
            items-center
            justify-center
            rounded
            focus:outline-none
            transition-colors
            duration-150
            text-sm
            p-3
            poppins
            bg-gray-400
            hover:bg-gray-800
            hover:text-white
            focus:bg-gray-800
            focus:text-white
          "
          :class="allowProcess() || allowReply() ? 'w-1/2' : 'w-full'"
          type="button"
          @click="processTicket(4)"
        >
          <template>Close Ticket</template>
        </button>
        <button
          v-else-if="ticketStatus == 4"
          class="
            w-full
            flex
            items-center
            justify-center
            focus:outline-none
            rounded
            text-sm
            p-3
            poppins
            bg-gray-400
            cursor-not-allowed
          "
        >
          Ticket Closed
        </button>
      </div>

      <div v-if="userCan('admin.helpdesk')" class="mt-4">
        <h2 class="font-medium poppins mb-4 text-lg">Flag Ticket</h2>
        <select
          class="form__input"
          v-model="ticketFlag"
          @change="setTicketFlag"
        >
          <option :value="null">(Select Flag)</option>
          <option v-for="(row, id) in listTicketFlag" :value="row.id" :key="id">
            {{ row.name }}
          </option>
        </select>
      </div>

      <div class="ticket-menu mt-10">
        <h2 class="font-medium poppins mb-4 text-lg">Support</h2>
        <router-link
          :to="{ name: 'SupportTicketList' }"
          class="block py-2 text-blue-500 font-medium text-sm hover:bg-blue-200"
          ><font-awesome-icon :icon="['fas', 'life-ring']" /> List Support
          Tickets</router-link
        >
        <router-link
          v-if="userCan('create.helpdesk')"
          :to="{ name: 'SupportTicketCreate' }"
          class="block py-2 text-blue-500 font-medium text-sm hover:bg-blue-200"
          ><font-awesome-icon :icon="['fas', 'edit']" /> New Ticket</router-link
        >
      </div>
    </div>

    <form
      class="form w-full"
      :class="formCreate ? '' : 'lg:w-8/12 xl:w-8/12'"
      method="POST"
      action="javascript:;"
      @submit.prevent="submit"
    >
      <FormError v-if="formError.length > 0" :errorMessages="formError" />

      <FormLoading v-if="!formReady" />

      <div v-else>
        <CardBase v-if="formCreate">
          <template #header v-if="formCreate">{{ $route.meta.title }}</template>
          <template #content>
            <div class="px-4 py-5 sm:p-6 bg-red-700 mb-6">
              <h3
                class="
                  leading-6
                  font-medium
                  text-white
                  flex
                  items-center
                  text-3xl
                  mb-4
                "
              >
                <font-awesome-icon
                  :icon="['fas', 'exclamation-triangle']"
                  class="mr-2"
                  size="2x"
                />
                Prosedur Pelaporan
              </h3>
              <div class="mt-2 text-lg text-white">
                <ul class="list-decimal list-outside ml-6 text-2xl">
                  <li>
                    Laporan
                    <span class="font-extrabold"
                      >WAJIB MENYERTAKAN FULL SCREENSHOT (tidak di potong /
                      crop) DAN LINK KE HALAMAN</span
                    >
                    tersebut.
                  </li>
                  <li>
                    Screenshot bisa langsung di paste (Ctrl-V).
                    <span class="font-extrabold"
                      >JANGAN BERIKAN SCREENSHOT MELALUI LINK KE WEBSITE LAIN.
                      LANGSUNG PASTE DI TIKET.</span
                    >
                  </li>
                  <li>
                    Pilih
                    <span class="font-extrabold">CATEGORY YANG SESUAI</span>.
                  </li>
                </ul>
              </div>
            </div>
            <FormRow class="mb-4" :required="true" v-if="formCreate">
              <template #label>Subject</template>
              <template #field>
                <input
                  :class="{
                    'form__input--error':
                      $v.formData.subject.$error && formSubmitted,
                  }"
                  type="text"
                  class="form__input"
                  placeholder="Title"
                  v-model="formData.subject"
                  :readonly="!formCreate"
                  :disabled="!formCreate"
                />
                <div
                  class="form-error"
                  v-if="$v.formData.subject.$error && formSubmitted"
                >
                  <span
                    class="form-error__text"
                    v-if="!$v.formData.subject.required"
                    >This field is required.</span
                  >
                </div>
              </template>
            </FormRow>

            <FormRow class="mb-4" :required="true" v-if="formCreate">
              <template #label>Category</template>
              <template #field>
                <multiselect
                  v-model="formData.category"
                  :options="listCategory"
                  :loading="listCategoryLoading"
                  :close-on-select="true"
                  :hide-selected="false"
                  :allow-empty="false"
                  :class="
                    $v.formData.category.$error ? 'multiselect--error' : ''
                  "
                  track-by="id"
                  label="name"
                  tag-placeholder="Press enter to choose"
                  placeholder="Search category"
                  :showLabels="false"
                >
                  <template #noResult>No results found.</template>
                </multiselect>
                <div
                  class="form-error"
                  v-if="$v.formData.category.$error && formSubmitted"
                >
                  <span
                    class="form-error__text"
                    v-if="!$v.formData.category.required"
                    >This field is required.</span
                  >
                </div>
              </template>
            </FormRow>

            <FormRow class="mb-4" :required="true">
              <template #label>Message</template>
              <template #field>
                <vue-editor
                  id="replyTicket"
                  v-model="formData.message"
                  :editorToolbar="customToolbar"
                ></vue-editor>
              </template>
            </FormRow>

            <FormDataLog :data="formData" v-if="!formCreate" />
          </template>

          <template #footer>
            <FormRow class="mb-0">
              <template #field>
                <BaseButton class="mr-2" type="submit">Submit</BaseButton>
              </template>
              <template #link>
                <div>
                  or
                  <router-link
                    :to="{ name: 'SupportTicketList' }"
                    class="link ml-2"
                    >Back to List Ticket</router-link
                  >
                </div>
              </template>
            </FormRow>
          </template>
        </CardBase>

        <div
          class="bg-white rounded mb-2 helpdesk"
          v-for="ticket in formData.tickets"
          :key="ticket.id"
        >
          <div>
            <div class="helpdesk__heading border-b border-gray-400 px-4 py-3">
              <div class="text-sm flex items-center">
                <font-awesome-icon
                  :icon="['fas', 'user']"
                  class="mr-2"
                  :class="
                    ticket.is_admin == 1 ? 'text-red-600' : 'text-gray-600'
                  "
                  size="sm"
                />
                <span class="block">{{ ticket.created_by.username }}</span>
              </div>
              <div class="flex justify-between mt-1 text-gray-600">
                <span class="text-xs" v-if="ticket.is_admin == 0">
                  ({{ ticket.created_by.group.name }}) -
                  {{ ticket.created_by.role.name }}
                </span>
                <span v-else>-</span>
                <span class="text-xs">{{ dateformat(ticket.created_at) }}</span>
              </div>
            </div>
            <div class="p-6 helpdesk__content" v-html="ticket.message"></div>
          </div>
        </div>

        <CardBase
          class="mb-6 mt-6"
          v-if="!formCreate && ticketStatus != 4 && replyOpen"
          :headerBorder="false"
        >
          <template #header>Reply Ticket</template>
          <template #content>
            <vue-editor
              id="replyTicket"
              v-model="formData.message"
              :editorToolbar="customToolbar"
            ></vue-editor>
            <div
              class="form-error"
              v-if="$v.formData.message.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.message.required"
                >This field is required.</span
              >
            </div>
          </template>
          <template #footer>
            <FormRow class="mb-0">
              <template #field>
                <BaseButton class="mr-2" type="submit">Submit</BaseButton>
              </template>
              <template #link>
                <div>
                  or
                  <router-link
                    :to="{ name: 'SupportTicketList' }"
                    class="link ml-2"
                    >Back to List Ticket</router-link
                  >
                </div>
              </template>
            </FormRow>
          </template>
        </CardBase>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.ticket-menu {
  a {
    @apply transition-all duration-300;

    &:hover {
      padding-left: 20px;
    }
  }
}
</style>
<script>
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import { submitFormMixin } from "@/mixins/submitFormMixin";
import Multiselect from "vue-multiselect";

export default {
  mixins: [submitFormMixin],
  components: {
    VueEditor,
    Multiselect,
  },
  data: () => {
    return {
      listCategory: [],
      listCategoryLoading: true,
      listTicketFlag: [],
      listTicketFlagLoading: false,
      replyOpen: false,
      formData: {
        subject: "",
        message: "",
        tickets: [],
      },
      ticketFlag: null,
      ticketStatus: null,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image"],
      ],
    };
  },
  validations: {
    formData: {
      subject: {
        required,
      },
      message: {
        required,
      },
      category: {
        required,
      },
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint
        : "/" + this.$route.meta.endpoint + "/" + this.formData.id + "/reply";
    },
  },
  created() {
    this.getListCategory();

    if (this.userCan("admin.helpdesk")) {
      this.replyOpen = true;
      this.getListTicketFlag();
    }
  },
  methods: {
    setTicketFlag() {
      this.$store.commit("toggleLoading");

      this.$http
        .patch(
          process.env.VUE_APP_API_URL + "/ticket/" + this.formData.id + "/flag",
          {
            flag: {
              id: this.ticketFlag,
            },
          }
        )
        .then((res) => {
          this.$swal({
            position: "bottom-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
            title: res.data.message,
            icon: "success",
          });
        })
        .finally(() => {
          this.$store.commit("toggleLoading");
        });
    },
    getListTicketFlag() {
      this.listTicketFlagLoading = true;
      this.$http
        .get(process.env.VUE_APP_API_URL + "/ticket-flag")
        .then((res) => {
          this.listTicketFlag = res.data.data;
        })
        .finally(() => {
          this.listTicketFlagLoading = false;
        });
    },
    getListCategory() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/ticket-category")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listCategory = response.data;
            }
          }
        })
        .finally(() => {
          this.listCategoryLoading = false;
        });
    },
    allowProcess() {
      return (
        this.ticketStatus == 0 ||
        this.ticketStatus == 2 ||
        this.ticketStatus == 3
      );
    },
    allowReply() {
      return this.ticketStatus != 4;
    },
    parseStatus(id) {
      const status = {
        0: {
          name: "Open",
          color: "text-green-500",
        },
        1: {
          name: "In Progress",
          color: "text-blue-600",
        },
        2: {
          name: "Answered",
          color: "text-red-600",
        },
        3: {
          name: "User Reply",
          color: "text-yellow-600",
        },
        4: {
          name: "Closed",
          color: "text-gray-500",
        },
      };

      return status[id];
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };
            this.formData.message = "";
            this.ticketStatus = this.formData.status;

            if (this.formData.flag) {
              this.ticketFlag = this.formData.flag.id
            } else {
              this.ticketFlag = null;
            }

            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    processTicket(status) {
      this.formSubmitted = true;
      this.formLoading = true;

      this.$store.commit("toggleLoading");

      this.$http({
        method: "post",
        url: process.env.VUE_APP_API_URL + this.submitUrl,
        data: { status: status },
      })
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            this.$router.push({ name: this.$route.meta.baseRoute }, () => {
              this.$swal({
                position: "bottom-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
                title: res.data.message,
                icon: "success",
              });
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.formError = [];

            if (error.response.status == 404) {
              // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
            } else if (error.response.status == 409) {
              // this.formError[0] = error.response.data;
            } else {
              const { data } = error.response.data;
              for (var err in data) {
                this.formError.push(data[err]);
              }
            }
          }
        })
        .finally(() => {
          this.$store.commit("toggleLoading");
          this.formLoading = false;
          this.formSubmitted = false;
        });
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;

        this.$store.commit("toggleLoading");

        this.$http({
          method: "post",
          url: process.env.VUE_APP_API_URL + this.submitUrl,
          data: {
            subject: this.formData.subject,
            message: this.formData.message,
            category: this.formData.category,
          },
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push({ name: this.$route.meta.baseRoute }, () => {
                this.$swal({
                  position: "bottom-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 5000,
                  timerProgressBar: true,
                  title: res.data.message,
                  icon: "success",
                });
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
    setStatus(status) {
      this.formData.status = status;
    },
    dateformat(date, format = "dddd, Do MMMM YYYY (HH:mm)") {
      return this.moment(date).format(format);
    },
    relativeTimeFormat(date) {
      return this.moment(date).fromNow();
    },
  },
};
</script>
